import { useContext } from 'react';
import ChannelContext from '.';
import { useQuery } from 'react-apollo';
import defaultCountrySettingsQuery from './CountrySettingsQuery.gql';
function useCountrySettings({ countrySettingsQuery } = {
    countrySettingsQuery: defaultCountrySettingsQuery
}) {
    var _a, _b;
    const { selectedChannel } = useContext(ChannelContext);
    const result = useQuery(countrySettingsQuery, {
        variables: { id: selectedChannel.id.toString() }
    });
    const { data, loading } = result;
    const selectedCountrySettings = (_a = data === null || data === void 0 ? void 0 : data.channel) === null || _a === void 0 ? void 0 : _a.settings.countrySettings.find(countrySetting => {
        return countrySetting.countryCode === selectedChannel.country.code;
    });
    return {
        selectedCountrySettings,
        countrySettings: (_b = data === null || data === void 0 ? void 0 : data.channel) === null || _b === void 0 ? void 0 : _b.settings.countrySettings,
        loading
    };
}
export { useCountrySettings };
//# sourceMappingURL=useCountrySettings.js.map